import { dataHubs } from './data-hub/hubs'
import {
  menuItems,
  menuItemsDataHubFavoritesGroup,
  menuItemsDataHubOptionGroup,
  userMenuItems,
} from './menuItems'

export const mocks = {
  dataHubs,
  menuItems,
  menuItemsDataHubFavoritesGroup,
  menuItemsDataHubOptionGroup,
  userMenuItems,
}
